import React, { useState, useEffect } from 'react'
import logoVeris from '../assets/logoveris.svg'
import Logs from '../components/General/LogDetail'

const Sidebar = (props) => {
    const [menuModule, setMenuModule] = useState([])
    const [paramUser, setParamUser] = useState([])
    const [openMenus, setOpenMenus] = useState({})
    const [selectedMenu, setSelectedMenu] = useState(null)

    const menuPaths = {
        'Chat AI': global.ChatAI,
        'Tableros': global.TABLERO_LIST,
        'configuracionAreas': global.CONFIG_TEMAS,
        'configuracionTableros': global.CONFIG_DASH,
        'configuracionEmpresas': global.CONFIG_EMPRESAS,
        'seguridadRoles': global.SECURE_ROLES,
        'seguridadUsuarios': global.SECURE_USERS,
        'seguridadUsuariosBI': global.SECURE_USERSBI,
        'seguridadRolesBI': global.SECURE_ROLESNI,
    }

    useEffect(() => {
        const savedMenu = localStorage.getItem('selectedMenu')
        if (savedMenu) {
            setSelectedMenu(savedMenu)
        }

        const savedOpenMenus = JSON.parse(localStorage.getItem('openMenus')) || {}
        setOpenMenus(savedOpenMenus)

        const menu = props.menu
        if (menu) {
            const updatedMenu = menu.map((menuItem) => {
                return {
                    ...menuItem,
                    path: menuPaths[menuItem.descripcionOpcion] || null,
                    acciones: menuItem.acciones.map((accion) => ({
                        name: menuPaths[accion],
                        path: menuPaths[accion] || `/${accion}`,
                    })),
                }
            })
            setMenuModule(updatedMenu)
        }
        /*if (menu) {
            const updatedMenu = menu.map((menuItem) => {
                return {
                    ...menuItem,
                    path: menuPaths[menuItem.descripcionOpcion] || null,
                    acciones: menuItem.acciones.map((accion) => {
                        const accionName = menuPaths[accion] === "Areas" ? "Áreas" : menuPaths[accion];
                        console.log(accionName)
                        console.log(menuPaths[accion] || `/${accion}`)
                        return {
                            name: accionName,
                            path: menuPaths[accion] || `/${accion}`,
                        };
                    }),
                };
            });
            setMenuModule(updatedMenu);
        }*/
        

        const param = JSON.parse(localStorage.getItem('param'))
        if (param) {
            setParamUser(param)
        }
    }, [props.menu])

    const handleMenuClick = (menuName, path) => {
        if (path) {
            window.location.href = path
        }
        Logs.logDetail(localStorage.getItem('secuenciaUsuario'), "click menu " + menuName, menuName, path, localStorage.getItem('codigoUsuario'))
        setSelectedMenu(menuName)
        localStorage.setItem('selectedMenu', menuName)
    }

    const handleActionClick = (accion) => {
        let newPath = accion
        Logs.logDetail(localStorage.getItem('secuenciaUsuario'), "click menu " + newPath, accion.name, newPath, localStorage.getItem('codigoUsuario'))
        window.location.href = newPath
        setSelectedMenu(accion)
        localStorage.setItem('selectedMenu', accion)
    }

    const toggleMenu = (menuName, event) => {
        event.preventDefault()
        event.stopPropagation()
        setOpenMenus((prev) => {
            const newOpenMenus = {
                ...prev,
                [menuName]: !prev[menuName],
            }
            localStorage.setItem('openMenus', JSON.stringify(newOpenMenus))
            return newOpenMenus
        })
    }

    const handledCloseSession = () => {
        localStorage.clear()
        window.location.href = '/'
    }

    const getIconForMenu = (menuName) => {
        switch (menuName) {
            case 'Chat AI':
                return <i className="nav-icon fas fa-robot"></i>
            case 'Tableros':
                return <i className="nav-icon fas fa-table"></i>
            case 'Seguridad':
                return <i className="nav-icon fas fa-user-shield"></i>
            case 'Configuración':
                return <i className="nav-icon fas fa-cogs"></i>
            default:
                return <i className="nav-icon fas fa-th"></i>
        }
    }

    return (
        <aside className="main-sidebar sidebar-ligth-primary elevation-4">
            <a
                href={global.DETAUL_HOME}
                className="brand-link"
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60px' }}
            >
                <img
                    src={logoVeris}
                    alt="veris"
                    className="brand-image"
                    style={{ width: '50%', height: '120%' }}
                />
            </a>
            <div className="sidebar">
                <nav className="mt-2">
                    <ul className="nav nav-pills nav-sidebar" data-widget="treeview" role="menu" data-accordion="false">
                        {menuModule.map((menuItem) => (
                            <li
                                key={menuItem.codigoOpcion}
                                className={`nav-item ${openMenus[menuItem.descripcionOpcion] ? 'menu-open' : ''}`}
                            >
                                <a
                                    href={menuItem.acciones.length > 0 ? '!#' : menuItem.path}
                                    className={`nav-link ${selectedMenu === menuItem.descripcionOpcion ? 'active' : ''}`}
                                    onClick={(event) => {
                                        if (menuItem.acciones.length > 0) {
                                            toggleMenu(menuItem.descripcionOpcion, event)
                                        } else {
                                            handleMenuClick(menuItem.descripcionOpcion, menuItem.path)
                                        }
                                    }}
                                >
                                    {getIconForMenu(menuItem.descripcionOpcion)}
                                    <p>
                                        {menuItem.descripcionOpcion}
                                        {menuItem.acciones.length > 0 && (
                                            <span style={{ marginLeft: '10px' }}>
                                                <i className="right fas fa-angle-left"></i>
                                            </span>
                                        )}
                                    </p>
                                </a>
                                {menuItem.acciones.length > 0 && (
                                    <ul className={`nav nav-treeview ${openMenus[menuItem.descripcionOpcion] ? 'show' : 'collapse'}`}>
                                        {menuItem.acciones.map((accion) => (
                                            <li className="nav-item" key={accion.name}>
                                                <a
                                                    href="!#"
                                                    className={`nav-link ${selectedMenu === accion.name ? 'active' : ''}`}
                                                    onClick={(event) => {
                                                        event.preventDefault()
                                                        handleActionClick(accion.name)
                                                    }}
                                                >
                                                    <i className="far fa-circle nav-icon small-icon"></i>
                                                    <p>{accion.name === "Areas" ? "Áreas" : accion.name}</p>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                )}

                            </li>
                        ))}
                        <li className="nav-item">
                            <a href="!#" className="nav-link" onClick={handledCloseSession}>
                                <i className="nav-icon fas fa-sign-out-alt"></i>
                                <p>Cerrar sesión</p>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </aside>
    )
}

export default Sidebar
